import * as React from 'react';
import { loginUrl } from 'kts-platform-frame/entry/configUtils';
import { JSString } from 'kts-scaffold-framework/utils/kit';
import history from 'kts-platform-frame/routes/history';

export default class Login2 extends React.PureComponent {
    render() {
        if (window['$$_self'] === 'iframe') { //嵌入情况
            window.location.href = '/third?timeout=true';
        } else if (window['$$_thirdLogin']) {  //第三方公司登录页
            window.location.href = window['$$_thirdLogin'];
        } else {
            const redirectURL = JSString.getQueryString(window.location.search, 'redirectURL');
            const debug = window.location.port === '3000' ? 'debug=true' : '';

            if (redirectURL) {
                if (debug) {
                    window.location.href = `${loginUrl()}?${debug}&redirectURL=${redirectURL}`;
                } else {
                    window.location.href = `${loginUrl()}?redirectURL=${redirectURL}`;
                }
            } else {
                if (debug) {
                    window.location.href = `${loginUrl()}?${debug}`;
                } else {
                    window.location.href = `${loginUrl()}`;
                }
            }
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/Login/UI.Transfer/index.tsx